import { MultiStructuresInfoBoxCopy } from 'ComponentLibrary/src/widgets/AssetInfoBoxes/MultiStructuresInfoBox'
import { TFunction } from 'i18next'

export const getMultiStructuresInfoBoxCopy = (tCommon: TFunction): MultiStructuresInfoBoxCopy => ({
    sectionLabel: tCommon('structure'),
    title: tCommon('structures'),
    usageTypeLabel: tCommon('usageType'),
    actualConstructionYearLabel: tCommon('actualConstructionYear'),
    economicConstructionYearLabel: tCommon('economicConstructionYear'),
    usageTypeLabels: {
        residential: tCommon('structureUsageTypes.residential'),
        office: tCommon('structureUsageTypes.office'),
        retail: tCommon('structureUsageTypes.retail'),
        mixed: tCommon('structureUsageTypes.mixed'),
        garage: tCommon('structureUsageTypes.garage'),
        other: tCommon('structureUsageTypes.other'),
    },
})
